import './tags.scss'
import {useState} from "react";
import {Tag, Badge, Button, Flex, Text} from '@chakra-ui/react'
import {ChevronDownIcon, ChevronUpIcon} from '@chakra-ui/icons'

const MAX_SECURITIES = 40;
const PREVIEW_COUNT = 5;

const Tags = ({securities, setTagSelected, selectedTag}) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleClick = (security) => {
        if (selectedTag === security) {
            setTagSelected(null);
        } else {
            setTagSelected(security);
        }
    };

    const count = securities?.length || 0;
    const isOverLimit = count >= MAX_SECURITIES;
    const visibleSecurities = isOpen ? securities : securities.slice(0, PREVIEW_COUNT);
    const hiddenCount = count - PREVIEW_COUNT;

    return (
        <div className='tags-section'>
            <Flex align="center" gap={2} mb={2} wrap="wrap" className="tags-header">
                <Badge
                    colorScheme={isOverLimit ? 'red' : 'green'}
                    fontSize="0.8rem"
                    px={2}
                    py={1}
                    borderRadius="md"
                >
                    {count}/{MAX_SECURITIES}
                </Badge>

                {isOverLimit && (
                    <Text fontSize="sm" color="red.500" fontWeight="semibold">
                        Strategie in GAP interrotte
                    </Text>
                )}

                <Button
                    size="xs"
                    variant="ghost"
                    colorScheme="gray"
                    onClick={() => setIsOpen(prev => !prev)}
                    rightIcon={isOpen ? <ChevronUpIcon/> : <ChevronDownIcon/>}
                    ml="auto"
                >
                    {isOpen ? 'Chiudi' : `Mostra tutti (${count})`}
                </Button>
            </Flex>

            <Flex wrap="wrap">
                {visibleSecurities.map((security, index) => (
                    <Tag
                        onClick={() => handleClick(security)}
                        className={`tag ${selectedTag === security ? 'active' : ''}`}
                        key={index}
                    >
                        {security}
                    </Tag>
                ))}
                {!isOpen && hiddenCount > 0 && (
                    <Tag
                        className="tag tag-more"
                        variant="outline"
                        onClick={() => setIsOpen(true)}
                    >
                        +{hiddenCount} altri...
                    </Tag>
                )}
            </Flex>
        </div>
    );
}

export default Tags;
